import store from 'store';
import {
  PATIENT_API_BASE_URL,
  MEDICAL_HISTORY_ENDPOINT_SUFFIX,
  HEALTH_SCREENING_ENDPOINT_SUFFIX, HEALTH_SCREENING_ANONYMOUS_ENDPOINT_SUFFIX
} from '../config/api-endpoints'
import { authorizeHeader } from '../utils/auth-header'
import AuthService from '../services/AuthService'
import { LOCAL_STORAGE_AUTH_KEY, MENTAL_HEALTH_CATEGORY_REF_HEALTH_SCREENING_KEY } from '../config/constants'

export const getMedicalHistoryDetailAPICall = async (limit, offSet) => {
  const auth = new AuthService()
  const profile = auth.getUserProfile()
  const { guid } = profile
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = `${PATIENT_API_BASE_URL + guid + MEDICAL_HISTORY_ENDPOINT_SUFFIX}?limit=${limit}&offset=${offSet}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw Error(`Response is not a JSON.`);
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return e
  }
}

export const putMedicalHistoryAPICall = async (requestBody) => {
  const auth = new AuthService()
  const profile = auth.getUserProfile()
  const { guid } = profile
  const data = {
    data: requestBody,
    medicle_category_ref: MENTAL_HEALTH_CATEGORY_REF_HEALTH_SCREENING_KEY
  }
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
    const endpointToHit = PATIENT_API_BASE_URL + guid + MEDICAL_HISTORY_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 200 || await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const postHealthScreeningGuestAPICall = async (requestBody) => {
  let guestIdPatient = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
  const profileFamily = store.get(LOCAL_STORAGE_AUTH_KEY.FAMILY_PROFILE_SIGNUP);
  if (profileFamily !== undefined) {
    guestIdPatient = profileFamily.guid
  }
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    const endpointToHit = PATIENT_API_BASE_URL + guestIdPatient + HEALTH_SCREENING_ANONYMOUS_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, config)
    const responseOk = await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}

export const getMedicalHistoryHealthScreeningAPICall = async () => {
  const auth = new AuthService()
  const profile = auth.getUserProfile()
  const { guid } = profile
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const endpointToHit = `${PATIENT_API_BASE_URL + guid + HEALTH_SCREENING_ENDPOINT_SUFFIX}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw Error(`Response is not a JSON.`);
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
    return e
  }
}

export const putMedicalHistoryHealthScreeningAPICall = async (requestBody) => {
  const auth = new AuthService()
  const profile = auth.getUserProfile()
  const { guid } = profile
  const data = {
    data: requestBody,
    medicle_category_ref: MENTAL_HEALTH_CATEGORY_REF_HEALTH_SCREENING_KEY
  }
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }
    const endpointToHit = PATIENT_API_BASE_URL + guid + HEALTH_SCREENING_ENDPOINT_SUFFIX
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseOk = await response.status === 200 || await response.status === 201
    const responseJSON = await response.json()
    return { responseOk, responseJSON }

  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('ERROR: ', e)
    return e
  }
}